import React, { useContext, useEffect } from "react";
import propTypes from 'prop-types';
import _ from 'lodash';
import { Button } from '_ui-core-js/React/components/Button.jsx';
import { NavigationContext } from "../store/contexts/NavigationContext";
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js/constants/analytics.js';

export function Link(props) {
    const { navigateToActions } = useContext(NavigationContext);
    const { dataAttributes } = props;

    const onClickActionToBeMapped = _.find(dataAttributes, {key:'onClickAction'})
    let callbackFunction = _.noop()
    
    if (onClickActionToBeMapped?.value) {
        callbackFunction = navigateToActions[onClickActionToBeMapped.value]
    };

    return (
        <Button {...{...props, onClickCallback: callbackFunction}} />
    );
}

Link.defaultProps = {
  gtmAction: CORE_GTM_TRACKING_VALUES.action.clickLink,
};

Link.propTypes = {
    type: propTypes.string.isRequired,
    label: propTypes.string.isRequired,
    target: propTypes.string,
    href: propTypes.string,
    overlay: propTypes.string,
    cssAnimation: propTypes.bool,
    cssAnimationTrigger: propTypes.oneOfType([
      propTypes.string,
      propTypes.bool
    ]),
    cssAnimationDelay: propTypes.number,
    hoverAnimation: propTypes.bool,
    onClickCallback: propTypes.func,
    brand: propTypes.string,
    id: propTypes.string,
    gtmAction: propTypes.string,
  };
